import { AxisKey } from "./types";

// TODO(SD-837): the per-axis career-family lists are illustrative starting
// points, not validated occupational mappings. Each entry is just an i18n key;
// the canonical English copy lives in public/locales/en/translation.json under
// cognitiveProfile.careerFamilies.<axis>.<key>. Before scaling this to other
// regions or marketing surfaces:
//   - source families from a structured taxonomy (O*NET, ESCO, etc.)
//   - drop the duplication with professions.ts — career-family chips on the
//     per-axis breakdown and the matching engine in professions.ts have grown
//     in parallel. Pick one source of truth.
export const CAREER_FAMILY_KEYS_PER_AXIS: Record<AxisKey, string[]> = {
  problemSolving: [
    "cognitiveProfile.careerFamilies.problemSolving.research",
    "cognitiveProfile.careerFamilies.problemSolving.engineering",
    "cognitiveProfile.careerFamilies.problemSolving.medicine",
    "cognitiveProfile.careerFamilies.problemSolving.law",
    "cognitiveProfile.careerFamilies.problemSolving.software",
    "cognitiveProfile.careerFamilies.problemSolving.strategy",
  ],
  readingProcessingSpeed: [
    "cognitiveProfile.careerFamilies.readingProcessingSpeed.journalism",
    "cognitiveProfile.careerFamilies.readingProcessingSpeed.editing",
    "cognitiveProfile.careerFamilies.readingProcessingSpeed.translation",
    "cognitiveProfile.careerFamilies.readingProcessingSpeed.education",
    "cognitiveProfile.careerFamilies.readingProcessingSpeed.communications",
    "cognitiveProfile.careerFamilies.readingProcessingSpeed.paralegal",
  ],
  numericalReasoning: [
    "cognitiveProfile.careerFamilies.numericalReasoning.finance",
    "cognitiveProfile.careerFamilies.numericalReasoning.accounting",
    "cognitiveProfile.careerFamilies.numericalReasoning.dataAnalysis",
    "cognitiveProfile.careerFamilies.numericalReasoning.engineering",
    "cognitiveProfile.careerFamilies.numericalReasoning.sciences",
  ],
  attentionSelfControl: [
    "cognitiveProfile.careerFamilies.attentionSelfControl.surgery",
    "cognitiveProfile.careerFamilies.attentionSelfControl.qualityAssurance",
    "cognitiveProfile.careerFamilies.attentionSelfControl.accounting",
    "cognitiveProfile.careerFamilies.attentionSelfControl.driving",
    "cognitiveProfile.careerFamilies.attentionSelfControl.projectCoordination",
  ],
  visualTrackingCoordination: [
    "cognitiveProfile.careerFamilies.visualTrackingCoordination.surgery",
    "cognitiveProfile.careerFamilies.visualTrackingCoordination.design",
    "cognitiveProfile.careerFamilies.visualTrackingCoordination.sports",
    "cognitiveProfile.careerFamilies.visualTrackingCoordination.piloting",
    "cognitiveProfile.careerFamilies.visualTrackingCoordination.skilledTrades",
    "cognitiveProfile.careerFamilies.visualTrackingCoordination.visualArts",
  ],
};
